<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            v-if="formParam.header.id!='' && formParam.header.id!=null"
          >Edit Widget Chat</h5>
          <h5 class="modal-title" v-else>Tambah Widget Chat</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="tab-content">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        Header Title:
                        <span class="text-danger">*</span>
                      </label>
                      <input
                        v-model="formParam.header.title"
                        placeholder="Misal: Tim kami siap membantu Anda jika ada pertanyaan."
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-6">
                          <label>
                            Domain:
                            <span class="text-danger">*</span>
                          </label>

                          <input
                            v-model="formParam.header.domain"
                            placeholder="https://www.yoursite.com"
                            type="text"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-6">
                          <label>
                            Widget Mode:
                            <span class="text-danger">*</span>
                          </label>
                          <select v-model="formParam.header.mode_widget" class="form-control">
                            <option :value="''">Select</option>
                            <template v-for="(row,idx) in widgetChatModeRows">
                              <option :key="idx" :value="row.id">{{row.label}}</option>
                            </template>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        Operators:
                        <span class="text-danger">*</span>
                      </label>
                      <div class="text-muted">
                        The smaller value that you input in
                        <b>Priority</b>, The Operator will be prioritized.
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div
                        class="row"
                        v-for="(rowSome,indxSome) in formParam.detail"
                        :key="indxSome"
                      >
                        <div class="col-md-8">
                          <div class="form-group form-focus select-focus">
                            <label>Operator</label>
                            <select
                              v-model="formParam.detail[indxSome].operator_id"
                              style="width:100%"
                            >
                              <option :value="''">Select</option>
                              <template v-for="(row,idx) in operatorRows">
                                <option
                                  :value="row.id"
                                  :key="idx"
                                >{{row.public_name}} - {{row.phone_number}}</option>
                              </template>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <label>Priority</label>
                          <input
                            v-model="formParam.detail[indxSome].operator_priority"
                            placeholder="Priority"
                            type="number"
                            style="width:100%"
                          />
                        </div>
                        <div class="col-md-1">
                          <a
                            v-if="indxSome==0 && formParam.detail.length==1"
                            @click.prevent="addRow"
                          >
                            <i class="fa fa-plus"></i>
                          </a>
                          <template v-else-if="indxSome>0 && indxSome==(formParam.detail.length-1)">
                            <a @click.prevent="addRow">
                              <i class="fa fa-plus"></i>
                            </a>
                            <a @click.prevent="removeRow(indxSome,(formParam.detail.length-1))">
                              <i class="fa fa-minus"></i>
                            </a>
                          </template>
                          <a
                            v-else
                            @click.prevent="removeRow(indxSome,(formParam.detail.length-1))"
                          >
                            <i class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <!-- {{isSending}} -->
                    <button @click="saveForm(0,1)" class="btn btn-md btn-warning" type="button">
                      <i class="fa fa-save"></i> Draft
                    </button>

                    <button
                      @click.prevent="saveForm(0,0)"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Publish
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <button
                      @click.prevent="saveForm(1,0)"
                      class="btn btn-lg btn-info"
                      type="button"
                    >
                      <i class="fa fa-check"></i> Publish &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    Datetime
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      operatorParams: {
        columnFilters: {
          keywords: "",
          is_publish: "publish"
        },
        page: 1,
        perPage: 500 // perPage
      },
      widgetChatModeLoading: false,
      widgetChatModeRows: [],
      domainRows: [],
      operatorRows: [],
      operatorLoading: false,
      isSending: false,
      formParam: {
        header: {
          id: "",
          title: "",
          domain: "",
          mode_widget: "",
          fb_pixel_id: "",
          fb_pixel_event: "PageViews",
          fb_pixel_currency: "IDR",
          fb_pixel_amount: 0,
          g_tag_id: "",
          is_publish: 0
        },
        detail: [
          {
            operator_id: "",
            operator_priority: 0
          }
        ]
      },
      isLoading: false
    };
  },
  watch: {
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          var that = this;
          // console.log("that.formParamSRSt",that.formParamSRSt)
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamWidgetChatSt.header.id != "" &&
              that.formParamWidgetChatSt.header.id != null
            ) {
              if (
                typeof that.formParamWidgetChatSt.header.copy != "undefined" &&
                that.formParamWidgetChatSt.header.copy == true
              ) {
                that.formParamWidgetChatSt.header.id = "";
              }

              // console.log("that.formParamSRSt", that.formParamSRSt);
              that.formParam = that.formParamWidgetChatSt;

              // that.uploadMessageType = "text";
              // if (that.formParam.header.message_type != "text") {
              //   that.formParam.header.is_enable_attach_file = true;
              //   that.uploadMessageType = that.formParam.header.message_type;
              // }
              // else {
              //   that.formParam.header.is_enable_attach_file = false;

              // }

              if (that.formParam.detail.length == 0) {
                {
                  that.formParam.detail.push({
                    operator_id: "",
                    priority: ""
                  });
                }
              }

              that.listWidgetChatMode();
              that.loadOperator();
              console.log("that.formParam", that.formParam);
            } else {
              that.listWidgetChatMode();
              that.loadOperator();
              that.formParam = {
                header: {
                  id: "",
                  title: "",
                  domain: "",
                  mode_widget: "",
                  fb_pixel_id: "",
                  fb_pixel_event: "PageViews",
                  fb_pixel_currency: "IDR",
                  fb_pixel_amount: 0,
                  g_tag_id: "",
                  is_publish: 0
                },
                detail: [
                  {
                    operator_id: "",
                    operator_priority: 0
                  }
                ]
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    formParamWidgetChatSt() {
      return this.$store.state.toolkit.formParamWidgetChatSt;
    },
    isShowForm() {
      return this.$store.state.toolkit.isShowForm;
    }
  },
  methods: {
    addRow() {
      let newRow = {
        operator_id: "",
        operator_priority: 0
      };
      this.formParam.detail.push(newRow);
    },
    removeRow(removeIndex, maxIndex) {
      // console.log("removeIndex", removeIndex, maxIndex);
      if (removeIndex == 0 && maxIndex == 0) {
        return;
      }

      if (removeIndex > -1) {
        // only splice array when item is found
        this.formParam.detail.splice(removeIndex, 1); // 2nd parameter means remove one item only
      }
    },
    async listWidgetChatMode() {
      this.widgetChatModeLoading = await true;
      await this.$store
        .dispatch("toolkit/listWidgetChatMode") // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.widgetChatModeRows = data;
          this.widgetChatModeLoading = false;
        })
        .catch(error => {
          this.widgetChatModeLoading = false;
          console.log(error);
        });
    },

    async loadOperator() {
      this.operatorLoading = await true;
      this.operatorParams.page = 0;
      await this.$store
        .dispatch("toolkit/listOperator", this.operatorParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.operatorRows = data.data;
          this.operatorLoading = false;
        })
        .catch(error => {
          this.operatorLoading = false;
          console.log(error);
        });
    },

    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    async saveForm(isExit = 0, isDraft = 0) {
      if (typeof isDraft == "undefined") {
        this.formParam.header.is_publish = 1;
      } else {
        if (isDraft == 1) {
          this.formParam.header.is_publish = 0;
        } else {
          this.formParam.header.is_publish = 1;
        }
      }

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          this.formParam.header.num_clicks = parseFloat(
            this.formParam.header.num_clicks
          );
          this.formParam.header.num_operator = parseFloat(
            this.formParam.header.num_operator
          );
          this.formParam.header.fb_pixel_amount = parseFloat(
            this.formParam.header.fb_pixel_amount
          );
          this.formParam.header.create_datetime = new Date();
          this.formParam.header.update_datetime = new Date();
          this.formParam.header.member_id = parseInt(
            this.formParam.header.member_id
          );

          this.formParam.detail.forEach((row, idx) => {
            this.formParam.detail[idx]["operator_id"] = row.operator_id;
            this.formParam.detail[idx]["operator_priority"] = parseInt(
              row.operator_priority
            );
          });
          await this.$store
            .dispatch("toolkit/storeWidgetChat", this.formParam)
            .then(response => {
              let id = response.data.id;
              // this.isSending = false;
              if (this.formParam.header.id == "") {
                this.formParam = {
                  header: {
                    id: "",
                    title: "",
                    domain: "",
                    mode_widget: "",
                    fb_pixel_id: "",
                    fb_pixel_event: "PageViews",
                    fb_pixel_currency: "IDR",
                    fb_pixel_amount: 0,
                    g_tag_id: "",
                    is_publish: 0
                  },
                  detail: [
                    {
                      operator_id: "",
                      operator_priority: 0
                    }
                  ]
                };
              }
              this.isSending = false;

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
                // this.$route
                this.$router.push("/toolkit/widget/view?id=" + id);
              }
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/widget/form.vue